import { createRouter, createWebHistory } from 'vue-router'
import session from '@/utils/session'
import Layout from '@/views/Layout.vue'
import { captureOnboardingFragment, safeOnboardingPath, scrubOnboardingFragment } from '@/utils/joinContext'
import { createChunkLoadRecovery } from './chunkLoadRecovery'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    /** login */
    {
      path: '/',
      redirect: (to) => ({ path: '/auth', query: to.query }),
      component: Layout,
      children: [
        {
          path: '/auth',
          component: () => import('@/views/login/AuthFlow.vue'),
          meta: { requireAuth: false }
        },
        {
          path: '/join',
          component: () => import('@/views/join/StoreJoin.vue'),
          props: { kind: 'store_join', audience: 'store_join' },
          meta: { requireAuth: false, onboarding: true, onboardingKind: 'store_join' }
        },
        {
          path: '/join/counter/:publicId',
          component: () => import('@/views/join/StoreJoin.vue'),
          props: (route) => ({
            kind: 'counter_join',
            audience: 'counter_join',
            publicId: route.params.publicId
          }),
          meta: {
            requireAuth: false,
            onboarding: true,
            onboardingKind: 'counter_join',
            staticOnboardingLocator: true
          }
        },
        {
          path: '/invite',
          component: () => import('@/views/join/StoreJoin.vue'),
          props: { kind: 'membership_invitation', audience: 'membership_invitation' },
          meta: { requireAuth: false, onboarding: true, onboardingKind: 'membership_invitation' }
        },
        {
          path: '/login',
          redirect: (to) => ({ path: '/auth', query: to.query })
        },
        {
          path: '/:legacyPath(loginsms|loginpwd|loginsetpwd|loginresetpwd|loginforgetpwd|logininfo|googletel|googlesms|loginupdateinfo)',
          redirect: (to) => ({ path: '/auth', query: to.query })
        },
        {
          path: '/invalid',
          component: () => import('@/views/login/Invalid.vue'),
          meta: { requireAuth: false }
        },
        {
          path: '/verification',
          redirect: (to) => ({ path: '/auth', query: to.query })
        },

        {
          path: '/profile',
          component: () => import('@/views/login/Profile.vue'),
          meta: { requireAuth: true }
        }
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.onboarding) {
    if (to.meta.staticOnboardingLocator) scrubOnboardingFragment()
    else captureOnboardingFragment(to.meta.onboardingKind)
  }

  //check meta requireAuth
  if (to.meta.requireAuth) {
    let token = session.get('token')
    if (token) {
      next()
    } else {
      next({
        path: '/auth',
        query: to.query
      })
    }
  } else {
    next()
  }
})

const chunkLoadRecovery = createChunkLoadRecovery({
  storage: window.sessionStorage,
  location: window.location
})

router.onError((error, to) => {
  const recoveryRoute = to?.meta?.onboarding
    ? { ...to, fullPath: safeOnboardingPath(window.location) }
    : to
  chunkLoadRecovery.recover(error, recoveryRoute)
})

router.afterEach((to, from, failure) => {
  chunkLoadRecovery.clearAfterNavigation(failure)
})

export default router
